import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { useMutation } from '@apollo/client'
import { CREATE_TACHO_VEHICLE_FILE_MUTATION } from '../../mutations'
import { getTachoFileType } from '../../consts'
import { TachoFileUploadModal } from './tacho-file-upload-modal'
import { UploadModalButton } from './upload-modal-button'

const ERR_WRONG_TYPE = 'WRONG_TYPE'

interface UploadTachoVehicleFileProps {
  onUploadSuccess?: () => void
}

export const UploadTachoVehicleFile: React.FC<UploadTachoVehicleFileProps> = ({
  onUploadSuccess,
}) => {
  const translations = useTranslate({
    uploadVehicleFiles: 'activities.upload-vehicle-files',
    wrongFileTypeVehicle: 'activities.wrong-file-type-vehicle',
  })

  const [addFile] = useMutation(CREATE_TACHO_VEHICLE_FILE_MUTATION)

  return (
    <UploadModalButton
      renderModal={({ onClose }) => (
        <TachoFileUploadModal
          title={translations.uploadVehicleFiles}
          validateFile={file =>
            getTachoFileType(file.name) === 'vehicle' ? null : ERR_WRONG_TYPE
          }
          mapError={code =>
            code === ERR_WRONG_TYPE
              ? translations.wrongFileTypeVehicle
              : undefined
          }
          upload={async file => {
            const result = await addFile({
              variables: {
                input: { file, fileName: file.name, vehicleVin: '' },
              },
            })
            if (result.errors?.length || !result.data?.createTachoVehicleFile) {
              return { ok: false, error: result.errors?.[0]?.message ?? '' }
            }
            return {
              ok: true,
              id: result.data.createTachoVehicleFile.tachoVehicleFile?.id,
            }
          }}
          onClose={onClose}
          onUploadSuccess={onUploadSuccess}
        />
      )}
    />
  )
}
